/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_LabelInputs */

const en_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const id_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const ms_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mel:`)
};

const ca_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correu electrònic:`)
};

const cs_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail:`)
};

const da_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mail:`)
};

const de_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse:`)
};

const et_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-post:`)
};

const es_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico:`)
};

const fr_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse e-mail :`)
};

const hr_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail:`)
};

const it_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const lv_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-pasts:`)
};

const lt_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El. paštas:`)
};

const hu_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail:`)
};

const nl_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailadres:`)
};

const nb_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-post:`)
};

const pl_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail:`)
};

const pt_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail:`)
};

const ro_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresă de e-mail:`)
};

const sk_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const sl_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-pošta:`)
};

const fi_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sähköposti:`)
};

const sv_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-post:`)
};

const vi_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const tr_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta:`)
};

const el_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const bg_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имейл:`)
};

const ru_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электронная почта:`)
};

const sr_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имејл:`)
};

const uk_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Електронна пошта:`)
};

const ka_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მეილი:`)
};

const hi_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल:`)
};

const th_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อีเมล:`)
};

const ko_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일:`)
};

const zh_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮件：`)
};

const zh_tw_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子郵件：`)
};

const ja_email_label = /** @type {(inputs: Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メール:`)
};

/**
* | output |
* | --- |
* | "Email:" |
*
* @param {Email_LabelInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const email_label = /** @type {((inputs?: Email_LabelInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_LabelInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_email_label(inputs)
	if (locale === "ms") return ms_email_label(inputs)
	if (locale === "ca") return ca_email_label(inputs)
	if (locale === "cs") return cs_email_label(inputs)
	if (locale === "da") return da_email_label(inputs)
	if (locale === "de") return de_email_label(inputs)
	if (locale === "et") return et_email_label(inputs)
	if (locale === "es") return es_email_label(inputs)
	if (locale === "fr") return fr_email_label(inputs)
	if (locale === "hr") return hr_email_label(inputs)
	if (locale === "it") return it_email_label(inputs)
	if (locale === "lv") return lv_email_label(inputs)
	if (locale === "lt") return lt_email_label(inputs)
	if (locale === "hu") return hu_email_label(inputs)
	if (locale === "nl") return nl_email_label(inputs)
	if (locale === "nb") return nb_email_label(inputs)
	if (locale === "pl") return pl_email_label(inputs)
	if (locale === "pt") return pt_email_label(inputs)
	if (locale === "ro") return ro_email_label(inputs)
	if (locale === "sk") return sk_email_label(inputs)
	if (locale === "sl") return sl_email_label(inputs)
	if (locale === "fi") return fi_email_label(inputs)
	if (locale === "sv") return sv_email_label(inputs)
	if (locale === "vi") return vi_email_label(inputs)
	if (locale === "tr") return tr_email_label(inputs)
	if (locale === "el") return el_email_label(inputs)
	if (locale === "bg") return bg_email_label(inputs)
	if (locale === "ru") return ru_email_label(inputs)
	if (locale === "sr") return sr_email_label(inputs)
	if (locale === "uk") return uk_email_label(inputs)
	if (locale === "ka") return ka_email_label(inputs)
	if (locale === "hi") return hi_email_label(inputs)
	if (locale === "th") return th_email_label(inputs)
	if (locale === "ko") return ko_email_label(inputs)
	if (locale === "zh") return zh_email_label(inputs)
	if (locale === "zh-tw") return zh_tw_email_label(inputs)
	if (locale === "ja") return ja_email_label(inputs)
	return en_email_label(inputs)
});